import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María G.',
    location: 'Miami, FL',
    age: '68 años',
    text: 'Yo pensaba que a mi edad ya no había remedio. Pero con estos ejercicios en la silla, volví a caminar en el parque con mis nietos. ¡Gracias a Dios encontré esto!',
    rating: 5
  }, {
    name: 'Carmen R.',
    location: 'Los Angeles, CA',
    age: '72 años',
    text: 'Lo mejor es que no tengo que tirarme al suelo. Lo hago sentadita viendo mi novela. Mis rodillas se sienten como hace 20 años.',
    rating: 5
  }, {
    name: 'Lupita S.',
    location: 'Houston, TX',
    age: '64 años',
    text: 'El doctor me dijo que necesitaba cirugía. Probé esto primero y el dolor bajó tanto que cancelé la operación. Una bendición.',
    rating: 5
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-157">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-158">
        <div className="text-center mb-16" data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-160">
            Ellas ya recuperaron su independencia
          </h2>
          <p className="text-xl text-slate-600" data-id="element-161">
            Mujeres reales, resultados reales.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-162">
          {testimonials.map((t, i) => <div key={i} className="bg-stone-50 p-8 rounded-2xl shadow-sm border border-stone-100" data-id="element-163">
              <div className="flex gap-1 mb-4" data-id="element-164">
                {[...Array(t.rating)].map((_, i) => <Star key={i} className="h-5 w-5 text-amber-400 fill-current" data-id="element-165" />)}
              </div>
              <p className="text-slate-700 italic mb-6 text-lg" data-id="element-166">"{t.text}"</p>
              <div className="flex items-center gap-4" data-id="element-167">
                <div className="w-12 h-12 bg-emerald-200 rounded-full flex items-center justify-center text-emerald-800 font-bold text-xl" data-id="element-168">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-169">
                  <p className="font-bold text-slate-900" data-id="element-170">{t.name}</p>
                  <p className="text-sm text-slate-500" data-id="element-171">
                    {t.location} • {t.age}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}